import React, { createContext, ReactNode, useContext, useState } from 'react';
import { StorageHelper } from '../../../utils/StorageHelper';
import { PrefijoPais } from '../../../types/PersonalData';

export type MisDatosContextType = {
  showModalPasaporteCifAction: (action: boolean) => void;
  showModalPasaporteCif: boolean;
  showModalContactEmail: () => void;
  showModalContactEmailForm: boolean;
  hideModalContactEmail: () => void;
  showModalTelefono1: () => void;
  showModalTelefono1Form: boolean;
  hideModaltelefono1: () => void;
  showModalTelefono2: () => void;
  showModalTelefono2Form: boolean;
  hideModaltelefono2: () => void;
  getModalTelefono1Form: () => void;
  getModalContactEmailForm: () => void;
  showModalContactEmailV2P: () => void;
  showModalServicioV2PForm: boolean;
  hideModalContactEmailV2P: () => void;
  setPrefijosPaisesHabilitados: (prefijos: PrefijoPais[]) => void;
  getPrefijosPaisesHabilitados: () => PrefijoPais[];
  flagTelefono1Incorrecto: boolean;
  showFlagTelefono1Incorrecto: () => void;
  hideFlagTelefono1Incorrecto: () => void;
  showModalV2P: () => void;
  hideModalV2P: () => void;
  showModalV2PPopup: boolean;
  showShowModalV2PPopupSamePage: () => void;
  hideShowModalV2PPopupSamePage: () => void;
  showModalV2PPopupSamePage: boolean;
};

const MisDatosContext = createContext<MisDatosContextType | undefined>(
  undefined,
);

export const MisDatosProvider = ({ children }: { children: ReactNode }) => {
  const [showModalV2PPopup, setShowModalV2PPopup] = useState(true);
  const [showModalV2PPopupSamePage, setShowModalV2PPopupSamePage] = useState(
    true,
  );
  const [showModalPasaporteCif, setShowModalPasaporteCif] = useState(false);
  const [showModalContactEmailForm, setShowModalContactEmailForm] = useState(
    false,
  );
  const [showModalTelefono1Form, setShowModalTelefono1Form] = useState(false);
  const [showModalTelefono2Form, setShowModalTelefono2Form] = useState(false);
  const [showModalServicioV2PForm, setShowModalServicioV2PForm] = useState(
    false,
  );
  const [prefijosPaises, setPrefijosPaises] = useState<PrefijoPais[]>([]);
  const [flagTelefono1Incorrecto, setFlagTelefono1Incorrecto] = useState(false);

  const showModalV2P = () => {
    setShowModalV2PPopup(true);
  };
  const hideModalV2P = () => {
    setShowModalV2PPopup(false);
  };
  const showShowModalV2PPopupSamePage = () => {
    setShowModalV2PPopupSamePage(true);
  };
  const hideShowModalV2PPopupSamePage = () => {
    setShowModalV2PPopupSamePage(false);
  };
  const setPrefijosPaisesHabilitados = (prefijos: PrefijoPais[]) => {
    setPrefijosPaises(prefijos);
  };
  const getPrefijosPaisesHabilitados = () => {
    return prefijosPaises;
  };
  const showModalPasaporteCifAction = (action: boolean) => {
    setShowModalPasaporteCif(action);
  };
  const showModalContactEmail = () => {
    StorageHelper.setshowModalContactEmail();
    setShowModalContactEmailForm(true);
  };
  const hideModalContactEmail = () => {
    StorageHelper.removeshowModalContactEmail();
    setShowModalContactEmailForm(false);
  };
  const getModalContactEmailForm = () => {
    // recuperar el valor del storage
    const emailSource = StorageHelper.getshowModalContactEmail();
    setShowModalContactEmailForm(emailSource === 'true');
  };
  const showModalTelefono1 = () => {
    // meter el servicio en el local storage true
    StorageHelper.setshowModalTelefono1();
    setShowModalTelefono1Form(true);
  };
  const hideModaltelefono1 = () => {
    // meter el servicio en el local storage false
    StorageHelper.removeshowModalTelefono1();
    setShowModalTelefono1Form(false);
  };
  const getModalTelefono1Form = () => {
    // recuperar el valor del storage
    const telefonoSource = StorageHelper.getshowModalTelefono1();
    setShowModalTelefono1Form(telefonoSource === 'true');
  };
  const showModalTelefono2 = () => {
    setShowModalTelefono2Form(true);
  };
  const hideModaltelefono2 = () => {
    setShowModalTelefono2Form(false);
  };
  const showModalContactEmailV2P = () => {
    setShowModalServicioV2PForm(true);
  };
  const hideModalContactEmailV2P = () => {
    setShowModalServicioV2PForm(false);
  };
  const showFlagTelefono1Incorrecto = () => {
    setFlagTelefono1Incorrecto(true);
  };
  const hideFlagTelefono1Incorrecto = () => {
    setFlagTelefono1Incorrecto(false);
  };
  return (
    <MisDatosContext.Provider
      value={{
        showModalPasaporteCif,
        showModalPasaporteCifAction,
        showModalContactEmail,
        showModalContactEmailForm,
        hideModalContactEmail,
        showModalTelefono1,
        hideModaltelefono1,
        showModalTelefono1Form,
        showModalTelefono2,
        hideModaltelefono2,
        showModalTelefono2Form,
        getModalTelefono1Form,
        getModalContactEmailForm,
        showModalContactEmailV2P,
        hideModalContactEmailV2P,
        showModalServicioV2PForm,
        setPrefijosPaisesHabilitados,
        getPrefijosPaisesHabilitados,
        flagTelefono1Incorrecto,
        showFlagTelefono1Incorrecto,
        hideFlagTelefono1Incorrecto,
        showModalV2P,
        hideModalV2P,
        showModalV2PPopup,
        showShowModalV2PPopupSamePage,
        hideShowModalV2PPopupSamePage,
        showModalV2PPopupSamePage,
      }}
    >
      {children}
    </MisDatosContext.Provider>
  );
};

export const useMisDatosStore = () => {
  const context = useContext(MisDatosContext);
  if (!context) {
    throw new Error('useMisDatosStore must be used within a MisDatosProvider');
  }
  return context;
};
